<pbc-sorter [config]="KundenArtsSorterConfig" [sorter]="kundenArts.sorter$ | async" (sorterChange)="kundenArts.sorter$.next($event)"></pbc-sorter>
